export { default } from './ScoredTableNewOfferCard'
